import React from 'react';
import PropTypes from 'prop-types';
import { TextArea } from 'moet-core';
import { SpacerVertical, Typography } from '@klarna/bubble-ui';

const Question = ({ text, isLast = false, ...props }) => (
  <>
    <Typography textToken="text-style/text/paragraphs/tall/regular">{text}</Typography>
    <SpacerVertical extraSmall />
    <TextArea {...props} />
    {!isLast && <SpacerVertical medium />}
  </>
);

Question.propTypes = {
  text: PropTypes.node.isRequired,
  isLast: PropTypes.bool,
};

export default Question;
